import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { CLUB_EVENT_LIST, GLOBAL_STATE } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const CLUB_EVENTS = GLOBAL_STATE

export const { reducer: clubEventSlice } = createSlice({
  name: CLUB_EVENTS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.clubEventList.pending, state => {
        state[CLUB_EVENT_LIST].loading = true
      })
      .addCase(actionCreators.clubEventList.rejected, (state, action) => {
        state[CLUB_EVENT_LIST].loading = false
        state[CLUB_EVENT_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.clubEventList.fulfilled, (state, action) => {
        state[CLUB_EVENT_LIST].loading = false
        state[CLUB_EVENT_LIST].error = null
        state[CLUB_EVENT_LIST].data = action.payload
      })

    builder.addCase(actionCreators.clubEventListClear, state => {
      state[CLUB_EVENT_LIST] = defaultState()
    })
  },
})
